import React from "react";
import { Spin, Typography } from "antd";
import { TrapStatusData } from "../../types";
import AlertDialog from "./AlertDialog";
import "./index.css";

const { Title } = Typography;

type Props = {
  loading: boolean;
  trapStatusData: TrapStatusData[];
  handleClickDialog: (id: string) => void;
};

const TrapStatus: React.FC<Props> = ({
  loading,
  trapStatusData = [],
  handleClickDialog,
}) => {
  return (
    <div className="trap-status-dialog">
      <Spin spinning={loading}>
        <div className="trap-status-dialog-title">
          <Title level={4} className="trap-status-dialog-title-text ">
            Trap Status
          </Title>
        </div>
        <div
          className={`trap-status-dialog-alerts force-show-scrollbars ${
            trapStatusData.length > 0 ? "has-alerts" : "no-alerts"
          }`}
        >
          {trapStatusData.length > 0 &&
            trapStatusData.map((item: TrapStatusData) => (
              <AlertDialog
                key={item._id}
                item={item}
                onClick={handleClickDialog}
              />
            ))}
        </div>
      </Spin>
    </div>
  );
};

export default TrapStatus;
